import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { ProgressBarDetails } from '../../api/models/ProgressBarDetails';
import { SessionRequest } from '../../api/models/SessionRequest';
import { SessionResponse } from '../../api/models/SessionResponse';
import { ApiErrorCode, ConfirmationFlowConstants, HTML_HEADER, RouteURLConstants, ServiceURLConstants, UPS_PICKUP_POINT } from '../../constants/upplm.constants';
import { TranslateDataPipe } from '../../pipes/translation.pipe';
import { UpsCommonService } from '../../services/upplm.common.service';
import { ProgressBarService } from '../../services/upplm.progressbar.service';
import { UpplmSessionService } from '../../services/upplm.session.service';
import { BreadcrumbItem } from '../commonComponent/ups-breadcrumb/breadcrumbItem';

@Component({
    selector: 'placardexistsconfirmation',
    template: require('./placardExistsConfirmation.component.html')
})

export class PlacardExistsConfirmationComponent implements OnInit, AfterViewInit {
    public sessionData: SessionResponse;
    public pbDetails: ProgressBarDetails;
    @ViewChild('ConfirmationBox', { static: false }) ConfirmationBoxModal;
    @ViewChild('SessionErrorModal', { static: false }) SessionErrorModal;
    public paramsUrl: string = '?loc=en_US&placardid=';

    //--------------------------------------------------
    //Variables for Page Title and Header
    //--------------------------------------------------
    pageTitleText = '';
    ManageUPSText = '';
    public breadCrumbItems: BreadcrumbItem[] = [];
    messageCallUpsIfDifficulty: string;
    messagePlacardExist: string;

    constructor(private router: Router,
        private _sessionService: UpplmSessionService,
        private _commonService: UpsCommonService,
        private _pbService: ProgressBarService,
        private _translateData: TranslateDataPipe
    ) { }

    ngOnInit() {
        this.pageTitleText = this._translateData.transform('upplm.placardlocationdetails.confirmplacardtitle');
        this.messagePlacardExist = this._translateData.transform('upplm.placardexits.aplacardalreadyexist');
        this.messagePlacardExist = this.messagePlacardExist.replace('%[x]%', UPS_PICKUP_POINT);
        this.ManageUPSText = HTML_HEADER.MANAGE_UPPLOCATION_HEADER;
        this.createBreadCrumb();
        this.pbDetails = this._pbService.pb;
        this.sessionData = this._sessionService.sessionData;
        this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest()).subscribe((response: SessionResponse) => {
            if (response.commonResponse.isSuccess && response.key && response.locationDetails != null) {
                this.sessionData = response;
                if (response.locationDetails && response.locationDetails.countryKey) {
                    this.messageCallUpsIfDifficulty = this._commonService.getMessageCallUpsIfDifficulty(response.locationDetails.countryKey, this._translateData.transform('upplm.placardexits.callupsifdifficulty'));
                }
                this._sessionService.mapSessionResponse(response);
                if (this.sessionData.locationDetails.city == null) {
                    this.goToLocationDetails();
                }
            }
            else {
                this.SessionErrorModal.open();
            }
        });
    }

    goToLocationDetails() {
        this._pbService.pb = new ProgressBarDetails();
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
    }

    createSessionRequest(): SessionRequest {
        let request: SessionRequest = new SessionRequest();
        request.key = this.sessionData.key;
        request.locationDetails = this.sessionData.locationDetails;
        request.temporaryLocation = this.sessionData.temporaryLocation;
        request.contactDetails = this.sessionData.contactDetails;
        request.placardDetails = this.sessionData.placardDetails;
        request.pickupDetails = this.sessionData.pickupDetails;
        request.notificationDetails = this.sessionData.notificationDetails;
        request.placardID = this.sessionData.placardID;
        request.lastTimeSessionReqired = new Date().toString();
        return request;
    }

    ngAfterViewInit() {
        this.ConfirmationBoxModal.setProperties({
            title: ConfirmationFlowConstants.SESSION_TEMED_OUT_TITLE
        });
        this.SessionErrorModal.setProperties({
            title: ConfirmationFlowConstants.SERVICE_ERROR
        }); 
    }

    backPage() {
        if (this.sessionData.notificationDetails) {
            if (this.sessionData.notificationDetails.showStatusBar == true) {
                this._pbService.pb = new ProgressBarDetails();
                this._pbService.pb.showStatusBar = true;
            } else {
                this._pbService.pb = new ProgressBarDetails();
                this._pbService.pb.showStatusBar = false;
            }
        } else {
            this.pbDetails = new ProgressBarDetails();
            this._pbService.pb = this.pbDetails;
            this._pbService.pb.showStatusBar = true;
        }  
        this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
    }
    goToPlacardConfirmation() {
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_PLACARD_VERIFICATION_ROUTE + this.paramsUrl.concat(this.sessionData.placardID));
    }

    validateSessionAndNavigate(target: string) {
        if (!this._sessionService.isValidSession()) {
            this._pbService.pb = new ProgressBarDetails();
            this.ConfirmationBoxModal.open();
        } else {
            this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest()).subscribe((response: SessionResponse) => {
                if (response.commonResponse.isSuccess) {
                    this._sessionService.mapSessionResponse(response);
                    this.router.navigateByUrl(target);
                }
            });
        }
    }

    cancelGoDashboardPage() {
        this._sessionService.cleanSessionData(this._commonService.createURL(ServiceURLConstants.CLEAN_SESSION, ApiErrorCode.CLEAN_SESSION)).subscribe((response: any) => {
            this._pbService.pb = new ProgressBarDetails();
            this._pbService.pb.showStatusBar = false;
            this._sessionService.mapSessionResponse(response);
            this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE);
        });
    }

    createBreadCrumb() {
        this.breadCrumbItems = [];
        this.breadCrumbItems.push(new BreadcrumbItem('https://www.ups.com', this._translateData.transform('upplm.breadcrumb.home')));
        this.breadCrumbItems.push(new BreadcrumbItem(`https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/services/tracking.page`,
            this._translateData.transform('upplm.breadcrumb.tracking')));
        this.breadCrumbItems.push(new BreadcrumbItem(`https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/tracking/quantum-view.page`,
            this._translateData.transform('upplm.breadcrumb.manageinboundoutbundshipments')));
        this.breadCrumbItems.push(new BreadcrumbItem('https://www.ups.com/upplm/dashboard',
            `${this._translateData.transform('upplm.breadcrumb.manage')} UPS<sup>${String.fromCharCode(174)}</sup> Pickup Point ${this._translateData.transform('upplm.breadcrumb.locations')}`));
        this.breadCrumbItems.push(new BreadcrumbItem('', this._translateData.transform('upplm.placardlocationdetails.confirmplacardtitle')));
    }

}
